<template>
<div>
    <h4 class="title">{{ $t('emailSubscription.title') }}</h4>
    <div v-if="!success">
        <div class="input-container">
            <input
            :placeholder="$t('emailSubscription.placeHolder')"
            type="text"
            class="ui-input"
            v-model="email">
            <button
            @click="submit"
            class="ui-button primary-button short-button">
                {{ $t('emailSubscription.button') }}
            </button>
            <p class="error-message red" v-show="errorShow">{{ errorText }}</p>
        </div>
        <p class="note">{{ $t('emailSubscription.note') }}</p>
    </div>
    <div class="success-content" v-else>
        <span class="icon-icon_have success-icon"></span><span>{{ $t('emailSubscription.successText') }}</span>
    </div>
</div>
</template>

<script>
import { httpManager as http } from '@/common/js/HttpManager';
import { emailReg } from '@/config/reg';
import reolinkApiUrl from '@/config/reolinkApiUrl';

export default {

    props: {

        subject: String

    },

    data () {

        return {

            email: '',
            errorShow: false,
            errorText: '',
            success: false

        };

    },

    methods: {

        showError ( textKey ) {

            this.errorText = this.$t( textKey );
            this.errorShow = true;

        },

        async submit () {

            let email = this.email;
            if ( !emailReg.test( email )) {

                this.showError( 'errors.invalid_email' );
                return false;

            }
            try {

                let res = await http.httpRequest({

                    method: 'POST',
                    url: '/wp-json/reo-v2/subscriptions/?no-mobile-redirection=1',
                    data: {

                        email,
                        subject: this.subject

                    },
                    config: {

                        baseURL: reolinkApiUrl

                    }

                });

                if ( res.data.result.code ) {

                    let code = res.data.result.code;
                    if ( code === -7 ) {

                        this.showError( 'errors.duplicate_submission' );

                    } else if ( code === -5 ) {

                        this.showError( 'errors.frequent_submission' );

                    } else {

                        this.showError( 'errors.server_error' );

                    }

                } else {

                    this.success = true;

                }

            } catch ( err ) {

                console.error( err );
                this.showError( 'errors.server_error' );

            }

        }

    }

};
</script>

<style lang="less" scoped>
.note{
    margin-left: 0.26rem;
    font-size: 0.16rem;
    text-align: left;
}
.error-message{
    margin-top: 10px;
}
.title{
    font-size: 28px;
    font-weight: 500;
}
.input-container{
    margin: 0.3rem 0 0.16rem;
    text-align: left;
    padding-left: 0.26rem;
    .ui-input {
        line-height: 0.46rem;
        height: 0.46rem;
        border-radius: 23px;
        width: 416px;
        margin: 0 0.2rem 0 0;
        vertical-align: middle;
    }
    button{
        vertical-align: middle;
    }
}
.success-content{
    margin-top: 0.58rem;
    font-size: 0.18rem;
    .success-icon{
        color: #59CA46;
        font-size: 0.22rem;
        margin-right: 0.12rem;
    }
    span{
        vertical-align: middle;
    }
}

@media screen and (max-width: 1199px) {
    .note{
        margin-left: 0;
        text-align: center;
        font-size: .26rem;
    }
    .error-message{
        margin-top: 0.08rem;
        text-align: center;
        font-size: 0.24rem;
        font-weight: 500;
    }
    .title{
        font-size: 0.36rem;
        line-height: 1.2;
    }
    .input-container{
        margin: 0.4rem 0 0.2rem;
        text-align: center;
        padding-left: 0;
        .ui-input {
            width: 100%;
            line-height: 1.2;
            height: 0.78rem;
            border-radius: 100px;
            text-align: center;
            margin: 0;
        }
        button{
            width: 100%;
            margin-top: 0.24rem;
            height: .78rem;
            line-height: 1.2;
        }
    }
    .success-content{
        margin-top: 0.4rem;
        .success-icon{
            color: #59CA46;
            font-size: 0.5rem;
            display: block;
            margin-right: 0 auto;
        }
        span {
            color: #63c622;
            display: block;
            font-size: .26rem;
            font-weight: 500;
            margin-top: .1rem;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/emailSubscription.vue